// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".van-popup[data-v-42bf10af] {\n  border-radius: 0;\n}\n", ""]);
// Exports
module.exports = exports;
